import './team-block.scss';
import 'slick-carousel';

export default () => {
	// Slick Slider
	$( '.js-team-slider' ).slick( {
		dots: true,
		arrows: true,
		infinite: true,
		speed: 300,
		rows: 1,
		slidesToShow: 3,
		slidesToScroll: 1,
		variableWidth: true,
		appendArrows: '.team-block__slider-nav',
		appendDots: '.team-block__slider-nav',
		nextArrow:
      '<button class=\'slick-next\'><i class=\'icon-arrow-next\'></i></button>',
		prevArrow:
      '<button class=\'slick-prev\'><i class=\'icon-arrow-prev\'></i></button>',
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	} );
};
